/**
 * Series colours (`specs/M10-D2-widgets.md` §5.1).
 *
 * A dimension that carries its own colour wins — a status bucket brings the label's own hex out
 * of `bucketsOf`, which is why a chart of a status column looks like the board does. Only when
 * it does not is this cycle used.
 *
 * The **order** is monday's, read off the production capture (`prod-forecast-card.png` shows a
 * purple / bright-blue / egg-yolk stacked chart); the **hexes** are F7's own status palette, not
 * values eyeballed off a blurred screenshot — no raw hex may live outside
 * `packages/ui/src/tokens` (M0-F7 U1).
 */
import { statusColorHex } from '@elizmonday/ui';
import type { StatusColor } from '@elizmonday/shared';

export const SERIES_COLOR_NAMES: readonly StatusColor[] = [
  'purple',
  'bright_blue',
  'egg_yolk',
  'done_green',
  'stuck_red',
  'working_orange',
  'dark_blue',
  'sofia_pink',
  'grass_green',
  'brown',
];

export const SERIES_PALETTE: readonly string[] = SERIES_COLOR_NAMES.map((name) => statusColorHex(name));

export function seriesColor(index: number): string {
  return SERIES_PALETTE[index % SERIES_PALETTE.length]!;
}
